import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface IncidentDetectionLapseReview {
  controlling_office_could_detect_incident: boolean | null;
  controlling_office_detection_remarks: string | null;

  irregularities_reported: boolean | null;
  irregularities_reported_remarks: string | null;

  information_system_improvement_required: boolean | null;
  information_system_improvement_remarks: string | null;

  reasons_for_non_detection: string | null;
  non_detection_actions: string | null;
}

export interface GetIncidentDetectionLapseReviewResponse {
  incident_detection_lapse_review: IncidentDetectionLapseReview | null;
}

export interface UpsertIncidentDetectionLapseReviewRequest {
  incident_detection_lapse_review: IncidentDetectionLapseReview;
}

export const IncidentDetectionLapseReviewAPI = {
  get: async (
    case_id: string,
  ): Promise<GetIncidentDetectionLapseReviewResponse> => {
    const response: AxiosResponse<GetIncidentDetectionLapseReviewResponse> =
      await axiosInstance.get(
        `v1/cases/${case_id}/incident-detection-lapse-review`,
      );

    return response.data;
  },

  upsert: async (
    case_id: string,
    request: UpsertIncidentDetectionLapseReviewRequest,
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.put(
        `v1/cases/${case_id}/incident-detection-lapse-review`,
        request,
      );

    return response.data;
  },
};

export default IncidentDetectionLapseReviewAPI;